import React from 'react'
import LaunchIcon from '@mui/icons-material/Launch'
import styled from 'styled-components'
import {useI18n} from 'i18n/I18nContext'

export const ZapierGuide = () => {
  const {t} = useI18n()
  return (
    <div key={'zapier'}>
      <div className="mt-30">
        <div>
          <div>
            <h5 className="speaker__author-title">
              {t('zapierGuide.setupTitle')}
            </h5>
            <span className="speaker__author-info">
              {t('zapierGuide.lead')}
            </span>
            <StepsHolder>
              <StepHolder>
                <b>{t('zapierGuide.s1t')}</b>
                <p>{t('zapierGuide.s1b')}</p>
              </StepHolder>

              <StepHolder>
                <b>{t('zapierGuide.s2t')}</b>
                <p>{t('zapierGuide.s2b')}</p>
              </StepHolder>

              <StepHolder>
                <b>{t('zapierGuide.s3t')}</b>
                <p>{t('zapierGuide.s3b')}</p>
              </StepHolder>

              <StepHolder>
                <b>{t('zapierGuide.s4t')}</b>
                <p>{t('zapierGuide.s4b')}</p>
              </StepHolder>
            </StepsHolder>

            <a
              className="input__btn"
              href="https://zapier.com/"
              target="_blank"
              rel="noreferrer"
            >
              {t('zapierGuide.openZapier')} <LaunchIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

const StepsHolder = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

const StepHolder = styled.div`
  background: #ebebeb;
  border-radius: 5px;
  padding: 14px;
  min-height: 130px;
`
